module.exports = __webpack_public_path__ + "static/media/NewCaledoniaLTStdRg.28a888b9.svg";